import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

/**
 * Get the translation key for a team capability.
 * @param capability
 * @returns
 */
export function getTeamCapabilityTranslationKey(
	capability: Enums<"teamCapability">,
): TranslationKey {
	switch (capability) {
		case "receive-substitution-list-copy":
			return "organization.capabilities.receive_substitution_list_copy";
		case "crew-scheduling":
			return "organization.capabilities.crew_scheduling";
		case "vehicle-scheduling":
			return "organization.capabilities.vehicle_scheduling";
		case "manage-project":
			return "organization.capabilities.manage_project";
		case "invoice-approval":
			return "organization.capabilities.invoice_approval";
		default:
			return "general.unknown";
	}
}
